import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  root: {
    boxShadow: 'none',
    backgroundColor: 'white',
  },
  emptySection: {
    paddingBottom: 12,
  },
});

function EmptySection({ emptyMessage }) {
  const classes = useStyles();
  return <div className={classes.emptySection}>{emptyMessage}</div>;
}

export default EmptySection;
